<template>
  <b-card v-if="true">
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="6">
            <departamento-select
              v-model="filtro.departamentos"
              :multiple="true"
            />
          </b-col>
          <b-col cols="6">
            <documento-select
              v-model="filtro.documentos"
              :multiple="true"
              :nao-recorrente="false"
            />
          </b-col>
        </b-row>
        <b-row align-v="start">
          <b-col
            cols="3"
            class="mr-50"
          >
            <div class="w-100">
              <legend class="col-form-label pt-0">
                Competência
              </legend>
              <de-para-competencia v-model="filtro.competencia" />
            </div>
          </b-col>
          <b-col
            cols="3"
            class="mr-auto"
          >
            <status-select
              ref="statusExterno"
              v-model="filtro.status"
              :multiple="true"
            />
          </b-col>
          <b-col cols="auto">
            <legend class="col-form-label pt-0">
              &nbsp;
            </legend>

            <div style="padding-top:6.218px; display: flex; align-items: center; justify-content: center;">
              <UploadLote />
              <b-btn
                variant="none"
                class="btn-primary btn-sm mr-1 ml-1"
                @click.prevent.stop="limpar()"
              >
                Limpar
              </b-btn>
              <b-btn
                variant="none"
                class="btn-primary btn-sm"
                @click="aplicar()"
              >
                Aplicar
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr
      class="mx-0 mt-0 my-2"
      style="border-top: 1px solid #a3a4a66b !important;"
    >
    <b-row>
      <b-col cols="12">

        <vue-good-table
          ref="documentos"
          class="relatorio"
          :columns="colunas"
          :rows="documentos"
          row-style-class="clickable"
          :pagination-options="{
            enabled: true,
            perPage: 10
          }"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <drop @drop="onDrop($event, props.row)">
              <span
                v-if="props.column.field === 'status'"
                v-b-tooltip
                :title="getStatusHint(props.row.status)"
              >
                <font-awesome-icon
                  :class="{
                    'text-pendente': props.row.status === 'pendente',
                    'text-success': props.row.status === 'homologado',
                    'text-danger': props.row.status === 'recusado',
                    'text-blue': props.row.status === 'aguardandohomologacao',
                    'text-dispensado': props.row.status === 'dispensado'
                  }"
                  :icon="getIconeStatus(props.row.status)"
                  style="font-size:1.3rem !important;width:22px"
                />
              </span>
              <span v-else-if="props.column.field === 'complemento'">
                <tag-visualizacao
                  v-for="(com, $index) in props.row.complemento"
                  :key="$index"
                  :value="com"
                />
              </span>
              <span v-else-if="props.column.field === 'acoes'">
                <b-btn
                  v-b-tooltip.hover
                  title="Visualizar"
                  variant="none"
                  class="mr-50 btn-actions"
                  :disabled="props.row.naoSeAplica || !props.row.publicado"
                  @click="abrirVisualizarArquivo(props.row)"
                >
                  <font-awesome-icon
                    :icon="faExternalLinkAlt"
                    :class="props.row.publicado ? 'text-success' : 'text-primary'"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
                <b-btn
                  v-b-tooltip.hover
                  title="Enviar"
                  variant="none"
                  :disabled="props.row.naoSeAplica"
                  class="mr-50 btn-actions"
                  @click="abrirSalvarArquivo(props.row)"
                >
                  <font-awesome-icon
                    :icon="faCloudUploadAlt"
                    class="text-primary"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
                <b-btn
                  variant="none"
                  class="mr-50 btn-actions hubauditar-color"
                  style="display: inline-block;font-size: 13px;text-decoration: underline;padding: 0px 0.25rem;"
                  @click="naoSeAplica(props.row)"
                >
                  <font-awesome-icon
                    :icon="faWindowClose"
                    class="text-primary"
                    style="margin-right:.25rem"
                  />
                  <span v-if="!props.row.naoSeAplica">Não se aplica</span>
                  <span v-else>Desfazer</span>
                </b-btn>
                <b-btn
                  v-b-tooltip.hover
                  title="Histórico"
                  variant="none"
                  class="btn-actions"
                  @click="abrirHistorico(props.row)"
                >
                  <font-awesome-icon
                    :icon="faHistory"
                    class="text-primary"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </drop>
          </template>
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhum documento foi encontrado.
            </p>
          </div>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Total: {{ props.total }} itens </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="10"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>

                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <nao-se-aplica-modal
      v-if="mostrarNaoSeAplica"
      @cancelar="cancelarNaoSeAplica()"
      @hidden="aplicarNaoSeAplica(docSelecionado, true, $event)"
    />
    <historico-modal
      v-if="mostrarHistorico"
      :documento-id="docSelecionado.id"
      @hidden="fecharHistorico()"
    />
    <salvar-arquivo-modal
      v-if="mostrarSalvarArquivo"
      @cancelar="cancelarSalvarArquivo()"
      @hidden="salvarArquivoNuvem(docSelecionado, $event)"
    />
    <visualizar-arquivo
      v-if="mostarArquivo && arquivo.url"
      :url="arquivo.url"
      :observacao="arquivo.observacao"
      @hidden="fecharVisualizarArquivo()"
    />
    <div v-show="isLoading">
      <div
        class="loading"
        style="background-color: #f7f7f785;"
      >
        <i class="fa-spin fas fa-spinner fa-4x hubauditar-color" />
      </div>
      <b-button
        variant="danger"
        class="button-cancel"
        @click="cancelarUpload()"
      >
        Cancelar
      </b-button>
    </div>
    <ListFile
      v-if="arquivos.length"
      @removeArquivos="removerArquivosEmLoteDoServidor"
    />
    <div v-else />
  </b-card>
</template>

<style lang="scss">
.homologacao-coluna {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.btn-actions {
  padding: 0 !important;
}

.relatorio {
  table.vgt-table {
    font-size: 1.03rem !important;
  }
}

.column-icon {
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  margin-right: 0.5rem;
}

.text-dispensado {
  color: #f5b700 !important;
}

.text-pendente {
  color: #ff6b35 !important;
}

@import "@core/scss/vue/libs/vue-good-table.scss";

.th-acao {
  width: 8rem !important;
}

.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.main-menu.menu-dark .navigation>li ul li>a {
  padding: 8px 10px 8px 12px;
}

.icone-acao {
  padding: 0.4rem;
}

.info-close {
  padding: 0 0.62rem 0.2rem 0.62rem !important;
  margin: -0.1rem -0.5rem -0.8rem auto !important;
}

.complemento-badge {
  margin-right: 0.3rem;
  background-color: transparent;
  border: 1px solid #82868b !important;
  color: #82868b;
  height: 1.5rem;
  font-size: 12px;
  font-weight: 700;
}

.remove-padding {
  padding: 0.75rem 0.15rem !important;
}

.text-blue {
  color: #549fc7 !important;
}

//Loading
.loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading i {
  position: absolute;
  opacity: 1;
}

.button-cancel {
  position: fixed;
  left: 42.5%;
  bottom: 5%;
  z-index: 99999 !important;
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  faHistory, faExternalLinkAlt, faHourglass, faTimesCircle, faCheckCircle, faExclamationCircle, faWindowClose, faCloudUploadAlt,
} from '@fortawesome/free-solid-svg-icons'
import { mapGetters, mapActions } from 'vuex'
import { Drop } from 'vue-easy-dnd'
import { enviarNuvem } from '@/shared/mixins/upload-wasabi/upload-wasabi'
import api from './shared/services/api'

export default {
  name: 'PortalDocumentoExterno',
  components: {
    Drop,
    VueGoodTable,
    FontAwesomeIcon,
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    DocumentoSelect: () => import('@/shared/components/documento-select/DocumentoSelect.vue'),
    DeParaCompetencia: () => import('@/shared/components/de-para-competencia/DeParaCompetencia.vue'),
    NaoSeAplicaModal: () => import('./shared/components/nao-se-aplica/NaoSeAplica.vue'),
    HistoricoModal: () => import('./shared/components/historico/Historico.vue'),
    SalvarArquivoModal: () => import('./shared/components/salvar-arquivo/SalvarArquivo.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
    TagVisualizacao: () => import('@/shared/components/tag-visualizacao/TagVisualizacao.vue'),
    StatusSelect: () => import('@/shared/components/status-select/StatusSelect.vue'),
    UploadLote: () => import('./shared/components/upload-lote/UploadLote.vue'),
    ListFile: () => import('./shared/components/upload-lote/ListaDeArquivos.vue'),

  },
  data() {
    return {
      faHistory,
      faExternalLinkAlt,
      faHourglass,
      faTimesCircle,
      faCheckCircle,
      faExclamationCircle,
      faWindowClose,
      faCloudUploadAlt,
      colunas: [
        {
          label: 'Status', field: 'status', width: '82px', tdClass: 'text-center',
        },
        { label: 'Documento', field: 'documento' },
        { label: 'Complemento', field: 'complemento' },
        {
          label: 'Competência',
          field: 'competencia',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
          dateOutputFormat: 'MM/yyyy',
        },
        {
          label: 'Cobrança',
          field: 'cobranca',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS',
          dateOutputFormat: 'dd/MM/yyyy HH:mm',
        },
        {
          label: 'Enviado',
          field: 'enviado',
        },
        { label: 'Homologação', field: 'homologacao' },
        {
          label: 'Ações', field: 'acoes', width: '210px', tdClass: 'text-right remove-padding',
        },
      ],
      mostrarNaoSeAplica: false,
      mostrarHistorico: false,
      mostarArquivo: false,
      mostrarSalvarArquivo: false,
      arquivo: {},
      docSelecionado: null,
      documentos: [],
      filtro: {
        competencia: {},
      },
      isLoading: false,
      uploadCancelado: false,
    }
  },
  computed: {
    ...mapGetters('empresaExGlobal', ['empresa']),
    ...mapGetters('uploadLote', ['arquivos']),

  },
  created() {
    this.filtro.status = [
      { nome: 'Pendente', tipo: 'pendente' },
      { nome: 'Recusado', tipo: 'recusado' },
    ]
    // this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    this.filtro.empresa = this.mpresa
    this.aplicar()
    this.getArquivosCarregadosEmLoteByEmpresa()
  },
  methods: {
    ...mapActions('uploadLote', ['setArquivos', 'delete', 'removeItem']),
    setDocumento(documento, payload) {
      this.$set(documento, 'status', payload.data.status)
      this.$set(documento, 'publicado', payload.data.publicado)
      this.$set(documento, 'enviado', payload.data.publicadoEm)
      this.$set(documento, 'homologacao', payload.data.homologacao)
      this.notificarSucesso('Documentos enviados com sucesso! Nossos analistas entrarão em contato em caso de inconsistências.')
    },
    onDrop(e, documento) {
      if (documento.naoSeAplica) {
        this.$erro('Não é possivel arrasto um documentos para uma cobrança que esta como não se aplica.')
      } else {
        api.atualizaDocumentoStatusDeLote(documento.id, e.data)
          .then(payload => {
            this.setDocumento(documento, payload)
            const index = this.arquivos.findIndex(s => s.id === e.data.id)
            if (index > -1) {
              this.removeItem(index)
            }
          }).catch(err => {
            this.notificarErro('Não foi possível carregar o documento selecionado')
            throw err
          })
      }
    },
    getArquivosCarregadosEmLoteByEmpresa() {
      api.getArquivosCarregadosEmLoteByEmpresa(this.empresa.id)
        .then(payload => {
          this.setArquivos(payload.data)
        })
        .catch(err => {
          this.notificarErro('Não foi possível carregar os documentos')
          throw err
        })
    },
    removerArquivosEmLoteDoServidor() {
      this.$confirmar('Deseja remover os arquivos carregados?', '',
        'question', 'danger')
        .then(result => {
          if (result.value) {
            api.removerArquivosEmLoteDoServidor(this.arquivos)
              .then(() => {
                this.$sucesso('Documentos removidos com sucesso')
                this.delete()
              }).catch(err => {
                this.notificarErro('Não foi possível remover os documentos')
                throw err
              })
          }
        })
    },
    getIconeStatus(value) {
      if (value === 'aguardandohomologacao') {
        return this.faHourglass
      }

      if (value === 'pendente') {
        return this.faExclamationCircle
      }

      if (value === 'recusado') {
        return this.faTimesCircle
      }

      if (value === 'homologado') {
        return this.faCheckCircle
      }

      if (value === 'dispensado') {
        return this.faCheckCircle
      }

      return ''
    },
    getStatusHint(value) {
      if (value === 'aguardandohomologacao') {
        return 'Aguardando homologação'
      }

      if (value === 'pendente') {
        return 'Pendente'
      }

      if (value === 'recusado') {
        return 'Recusado'
      }

      if (value === 'homologado') {
        return 'Homologado'
      }

      if (value === 'dispensado') {
        return 'Dispensado'
      }

      return ''
    },
    aplicar() {
      if (!this.empresa) {
        this.notificarErro('Não foi encontrada nenhuma empresa selecionada.')
      } else {
        api.getCobrancas(this.empresa.id, this.filtro)
          .then(payload => {
            this.documentos = payload.data
          })
          .catch(err => {
            this.notificarErro('Não foi possível carregar os documento cobrados.')
            throw err
          })
      }
    },
    limpar() {
      this.documentos = []
      this.filtro = {
        departamentos: null,
        documentos: null,
        status: null,
        competencia: {},
      }
    },
    abrirVisualizarArquivo(documento) {
      this.docSelecionado = documento
      api.getURLDocumento(documento.id)
        .then(payload => {
          this.arquivo = payload.data
          this.mostarArquivo = true
        })
        .catch(err => {
          this.fecharVisualizarArquivo()
          this.notificarErro('Não foi possível carregar os documento cobrados.')
          throw err
        })
    },
    fecharVisualizarArquivo() {
      this.mostarArquivo = false
      this.docSelecionado = null
      this.arquivo = {}
    },
    abrirSalvarArquivo(documento) {
      this.mostrarSalvarArquivo = true
      this.docSelecionado = documento
    },
    salvarArquivoNuvem(documento, arquivo) {
      this.$isLoading(true)
      api.getDadosUpload(documento.id, arquivo)
        .then(response => {
          enviarNuvem(response.data.arquivoNovo, arquivo.get('file'), response.data.storage)
            .then(promise => {
              if (promise && promise.sucesso) {
                api.atualizaDocumentoStatus(documento.id, arquivo, arquivo.get('body'))
                  .then(payload => {
                    this.setDocumento(documento, payload)
                    this.$isLoading(false)
                    this.cancelarSalvarArquivo()
                  })
                  .catch(err => {
                    api.limparEnvioDocumentoNuvem(documento.id, arquivo)
                      .then(() => {
                        this.$isLoading(false)
                      })
                    const resolved = this.$resolveError(err)
                    const message = resolved.detail || resolved.title || err.message
                    this.notificarErro(message, documento)
                  })
              } else {
                this.menssagemErroDocumento('Não é possível realizar ações nessa cobrança.', documento, true)
              }
            })
        })
        .catch(err => {
          const resolved = this.$resolveError(err)
          const message = resolved.detail || resolved.title || err.message
          this.menssagemErroDocumento(message, documento, true)
          throw err
        })
    },
    cancelarSalvarArquivo() {
      this.mostrarSalvarArquivo = false
      this.docSelecionado = null
    },
    cancelarUpload() {
      this.uploadCancelado = true
      api.abortarUpload()
      this.isLoading = false
    },
    abrirHistorico(documento) {
      this.mostrarHistorico = true
      this.docSelecionado = documento
    },
    fecharHistorico() {
      this.mostrarHistorico = false
      this.docSelecionado = null
    },
    cancelarNaoSeAplica() {
      this.docSelecionado = null
      this.mostrarNaoSeAplica = false
    },
    naoSeAplica(documento) {
      if (!documento.naoSeAplica) {
        this.mostrarNaoSeAplica = true
        this.docSelecionado = documento
      } else {
        this.aplicarNaoSeAplica(documento, false)
        this.mostrarNaoSeAplica = false
        this.docSelecionado = null
      }
    },
    aplicarNaoSeAplica(documento, value, justificativa = '') {
      api.naoSeAplica(documento.id, value, justificativa)
        .then(payload => {
          this.$set(documento, 'status', payload.data.status)
          this.$set(documento, 'naoSeAplica', value)
          this.$set(documento, 'enviado', payload.data.publicadoEm)
          this.$set(documento, 'homologacao', payload.data.homologacao)
          this.$set(documento, 'publicado', false)
          this.cancelarNaoSeAplica()
        })
        .catch(err => {
          this.mostrarNaoSeAplica = false
          this.docSelecionado = null
          const resolved = this.$resolveError(err)
          const message = resolved.detail || resolved.title || err.message
          this.menssagemErroDocumento(message, documento, false)
          throw err
        })
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    notificarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'SuccessCircleIcon',
          variant: 'success',
        },
      })
    },
    menssagemErroDocumento(err, documento, mostrarUpload) {
      this.cancelarSalvarArquivo()
      this.$isLoading(false)
      this.$swal({
        icon: 'warning',
        title: 'Aviso',
        width: 600,
        text: err,
        confirmButtonText: 'OK, tentar novamente agora!',
        cancelButtonText: 'Ok, tentar mais tarde!',
        showCancelButton: true,
        focusConfirm: false,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-primary ml-1',
        },
      })
        .then(result => {
          if (result.value) {
            api.resetEnvioDocumento(documento.id)
              .then(() => {
                if (mostrarUpload) {
                  this.abrirSalvarArquivo(documento)
                }
              })
          }
        })
    },
  },
}
</script>
